<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="banners-galeria" v-if="(banners.list.length > 0 && banners.loaded)">
      <Galleria :value="banners.list" :circular="true" :showItemNavigators="true" :showThumbnails="false" :showIndicators="true" :autoPlay="true" :transitionInterval="5000">
        <template #item="slotProps">
          <!-- BANNER -->
          <div class="banner big-banner homepage-margin relative" style="display: flex;flex-wrap:wrap">
            <img :src="slotProps.item.imagem" alt="" class="banner-bg-image" />
            <figure class="banner-logo-image fadeZoom-in-right" :key="slotProps.item.id">
              <img :src="require('@/assets/banners/slider-logos.png')" alt="LogoAnimate" />
            </figure>
            <div class="w-7"></div>
            <div class="w-5 banner-text-container flex flex-column w-full">
              <div class="banner-text w-full" :key="slotProps.item.id">
                <div class="btnNew flex fadeinup animation-duration-1000" v-if="slotProps.item.emDestaque" v-html="fc_getText(null, 'novo')" ></div>
                <div class="titulo flex flex-column fadeinup animation-duration-1000" v-if="slotProps.item.titulo" v-html="slotProps.item.titulo" ></div>
                <div class="subtitulo flex gap-0">
                  <div class="text flex flex-column flex-grow-1 fade-in-left" v-if="slotProps.item.subtitulo" v-html="slotProps.item.subtitulo"></div>
                </div>
                <div @click="mt_go(slotProps.item)" class="btn-redireciona flex fadeindown animation-duration-1000 mt-5" v-if="slotProps.item.inserirBotao" v-html="mt_textBotaoRedirecionar(slotProps.item.botaoTipo)"></div>
              </div>
            </div>
          </div>
          <!-- BANNER MOBILE -->
          <div class="banner mobile-banner w-full homepage-margin">
            <img :src="slotProps.item.imagemEcraReduzido" alt="" class="bannerMobile-bg-image" />
            <div class="banner-text-container flex flex-column w-full">
              <div class="banner-text w-full sm:w-11">
                <div class="btnNew flex fadeinup animation-duration-1000" v-if="(slotProps.item.emDestaque)" v-html="fc_getText(null, 'novo')"></div>
                <div class="titulo flex flex-column fadeinup animation-duration-1000" v-if="(slotProps.item.titulo !== '')" v-html="slotProps.item.titulo"></div>
                <div class="subtitulo flex gap-0">
                  <div class="text flex flex-column flex-grow-1 fade-in-left animation-duration-1000" v-if="(slotProps.item.subtitulo !== '')" v-html="slotProps.item.subtitulo"></div>
                </div>
                <div @click="mt_go(slotProps.item)" class="btn-redireciona flex fadeindown animation-duration-1000 mt-6" v-if="(slotProps.item.inserirBotao)" v-html="mt_textBotaoRedirecionar(slotProps.item.botaoTipo)"></div>
              </div>
            </div>
          </div>
        </template>
      </Galleria>
    </div>
  </div>
</template>

<script>
import Galleria from 'primevue/galleria';

export default {
  components: {
    Galleria,
  },
  data() {
    return {
      loaded: false,
      banners: {
        loaded: false,
        list: []
      },
      menus: {}
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      this.fc_fetch({ endpoint: 'Banners/', method: 'GET', success: this.mt_loadData_success });
    },
    mt_loadData_success(response) {
      if (response != null && response.list != null) {
        this.banners.list = response.list;
        this.banners.loaded = true;
      }
      this.loaded = true;
    },
    mt_go(banner) {
      if (banner.redirecionarPara === 1) {
        if (banner.menu != null) {
          let route = this.menus.find((o) => o.id == banner.menu)
          if (route != null) {
            this.fc_goRoute(route.route);
          }
        }
      } else if (banner.redirecionarPara == 2 && banner.solucao != null) {
        this.fc_goRoute('solucao', { id: banner.solucao });
      } else if (banner.redirecionarPara == 3 && banner.noticia != null) {
        this.fc_goRoute('noticia', { id: banner.noticia });
      }
    },
    mt_textBotaoRedirecionar(tipo) {
      let textoBotao = '';
      if (tipo == 1) {
        textoBotao += this.fc_getText(null,'btn_verMais')
        return textoBotao;
      } else if (tipo == 2) {
        textoBotao += this.fc_getText(null,'btn_saberMais')
        return textoBotao;
      } else if (tipo == 3) {
        textoBotao += this.fc_getText(null,'btn_converseConnosco')
        return textoBotao;
      } else if (tipo == 4) {
        textoBotao += this.fc_getText(null,'btn_agendarDemo')
        return textoBotao;
      }
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'Menus/', method: 'GET', success: (response) => { this.menus = response.list; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style>
.banners-galeria .p-galleria {
  border:none !important;
}
.banners-galeria .p-galleria-indicators {
  position: relative;
  top: -60px;
  margin: 0px 80px;
  padding: 1rem 0rem;
}

.banners-galeria .p-galleria-indicator {
  height: 14px;
  width: 14px;
  margin-right: 3px;
  background-color: #000;
  border-radius: 50%;
  display: inline-block;
  cursor:pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.5s;
}
.banners-galeria .p-galleria-indicator .p-galleria-indicator-button {
  height: 4px;
  width: 4px;
  background-color: #fff;
  border-radius: 50%;
  position: absolute;
}
.banners-galeria .p-galleria-indicator.p-galleria-indicator-active {
  background-color: transparent;
}
.banners-galeria .p-galleria-indicator.p-galleria-indicator-active:hover {
  background-color: #ededed !important;
}
.banners-galeria .p-galleria-indicator.p-galleria-indicator-active .p-galleria-indicator-button {
  background-color: #000;
}
.banners-galeria .p-galleria-indicator:hover {
  background-color: #ededed;
}
.banners-galeria .p-galleria-indicator:hover .p-galleria-indicator-button {
  background-color: #000;
}
.banners-galeria .p-galleria-item-nav {
  top: auto;
  bottom: 0px;
  margin: 0.2rem;
}
.banners-galeria .p-galleria-item {
  width: 100%;
  height: 1040px;
  transition: height 0.3s ease;
}
@media screen and (max-width: 1200px) {
  .banners-galeria .p-galleria-item {
    max-height: 800px;
  }
}
@media screen and (max-width: 1040px) {
  .banners-galeria .p-galleria-item {
    max-height: 700px;
  }
}
@media screen and (max-width: 575px) {
  .banners-galeria .p-galleria-item {
    max-height: 600px;
  }
}

.banners-galeria .p-galleria-prev-button.p-galleria-nav-button,
.banners-galeria .p-galleria-next-button.p-galleria-nav-button,
.banners-galeria .p-galleria-nav-button:not(.p-disabled):hover {
  transform: matrix(1, 0, 0, 1, 0, -55);
  cursor: pointer;
  background: #000;
  background: rgba(0,0,0,0.5) !important;
  color:#fff;
  width: 30px;
  height: 110px;
  position: absolute;
  display: block;
  z-index:2;
}
.banners-galeria .p-galleria-next-button.p-galleria-nav-button:not(.p-disabled):hover svg {
  color:#fff;
  animation: fadeoutright .3s linear;
}
.banners-galeria .p-galleria-prev-button.p-galleria-nav-button:not(.p-disabled):hover svg {
  color:#fff;
  animation: fadeoutleft .3s linear;
}
.banners-galeria .p-galleria-indicator-list {
  transform: matrix(1, 0, 0, 1, 0, -113);
}
@media screen and (max-width: 1140px) {
  .banners-galeria .p-galleria-indicator-list {
    display:none !important;
  }
}
@media screen and (max-width: 576px) {
  .banners-galeria .p-galleria-prev-button.p-galleria-nav-button,
  .banners-galeria .p-galleria-next-button.p-galleria-nav-button {
    display:none !important;
  }
}
@media screen and (min-width: 1700px) {
  .banners-galeria .p-galleria-indicator-list {
    display:none !important;
  }
}

.fadeZoom-in-right {
  animation: fadeInRightZoom 0.3s ease-out forwards;
}
</style>
